exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".snowflakes-container {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    pointer-events: none;\r\n    overflow: hidden;\r\n}\r\n\r\n.snowflake {\r\n    position: absolute;\r\n    font-size: 1.5rem;\r\n    color: rgb(255, 255, 255);\r\n    -webkit-animation: fall linear infinite;\r\n            animation: fall linear infinite;\r\n}\r\n\r\n@-webkit-keyframes fall {\r\n    0% {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n    }\r\n    100% {\r\n        -webkit-transform: translateY(100vh);\r\n                transform: translateY(100vh);\r\n    }\r\n}\r\n\r\n@keyframes fall {\r\n    0% {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n    }\r\n    100% {\r\n        -webkit-transform: translateY(100vh);\r\n                transform: translateY(100vh);\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/views/view-user-tasks/view-user-tasks.component.css
// module id = ../../../../../src/app/content-page/views/view-user-tasks/view-user-tasks.component.css
// module chunks = main